var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 20,
    viewBox: "0 0 15 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2251_120333)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15 7.50003C15 12.9551 8.65391 19.3638 8.38406 19.634C8.1496 19.8683 7.83166 20 7.50016 20C7.16865 20 6.85071 19.8683 6.61625 19.634C6.34609 19.3637 0 12.9551 0 7.50003C0 5.5109 0.790176 3.60324 2.1967 2.19671C3.60322 0.79018 5.51088 0 7.5 0C9.48912 0 11.3968 0.79018 12.8033 2.19671C14.2098 3.60324 15 5.5109 15 7.50003ZM7.5 11.25C8.24168 11.25 8.9667 11.0301 9.58339 10.6181C10.2001 10.206 10.6807 9.62033 10.9645 8.9351C11.2484 8.24987 11.3226 7.49587 11.1779 6.76844C11.0333 6.04101 10.6761 5.37282 10.1517 4.84837C9.6272 4.32392 8.95902 3.96677 8.23159 3.82207C7.50416 3.67738 6.75016 3.75164 6.06494 4.03547C5.37971 4.3193 4.79404 4.79995 4.38199 5.41663C3.96993 6.03332 3.75 6.75835 3.75 7.50003C3.74998 7.9925 3.84696 8.48014 4.03541 8.93512C4.22386 9.39011 4.50008 9.80351 4.8483 10.1517C5.19653 10.5 5.60993 10.7762 6.06491 10.9646C6.51989 11.1531 7.00754 11.2501 7.5 11.25Z",
    fill: "#1B293F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2251_120333"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.8015635e845497f83fdc2f7ba4f895a1.svg";
export { ForwardRef as ReactComponent };